import VForm from "@/vuetify_custom/v-form";
import { VCard, VCardText, VRow, VCol, VBtn, VIcon } from "vuetify/lib";
// import SpecialTeamSelector from '@/vuetify_custom/v-form/components/Special_Team_Selector.js'
// import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import VPopDel from "./v-pop-d";
import ExpenseTypeUtil from "@/views/expense_type/libs/util";
// import VExpenseTypeSelector from './v-selector';
import TextField from "@/vuetify_custom/v-form/components/Text_Field.js";
import ReceiptFiveSelectMixins from "@/views/fin_bill/mixins/receipt_five_select_mixins.js";
import InvoiceInfoField from "@/vuetify_custom/v-form/components/Invoice_Info_Field.js";
import { financer_mix } from "./EditMixIns";
import components_hash from "@/vuetify_custom/v-form/components";
import { commonValidateRule, createTeam, createSpu } from "./utils";
import styles from "./index.module.less";
const NumberField = components_hash["number_field"];
const SpecialTeamSelector = components_hash["team_select"];
const AutoCompleteSelector = components_hash["autocompletes_async_v1"];
const commonValidateRuleGo = commonValidateRule("必选");
const commonValidateRuleGg = commonValidateRule("必填");
export default {
  mixins: [ReceiptFiveSelectMixins, financer_mix],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    total: {
      type: Number,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      expense: this.value,
      items: [],
    };
  },
  computed: {
    is_financer_assistant() {
      const cur_customer = this.$store.state.cur_customer;
      return (
        cur_customer.groups && cur_customer.groups.includes("GROUP_FIN_INTERN")
      );
    },
    team_price_total() {
      const total = this.expense.expense_teams
        .reduce((total, item) => {
          return math.eval(`${total}+${item.price || 0}`);
        }, 0)
        .toFixed(2);
      return Number(total);
    },

    finacer_fields() {
      return [
        this.cost_nature_field, // 费用nature
        this.customer_function_field, // 员工职能
        this.customer_types_field, // 员工类型
        this.item_type_field, // 产品类型
        this.fund_usage_field, // 费用用途
        this.insider_trading_field, // 是否是内部交易
        {
          type: "empty",
          cols: 6,
        },
        this.account_title_field_readonly, // 会计科目
        this.analysis_title_field_readonly, // 分析科目
      ];
    },
    needSpu() {
      return (
        this.params.contract_source &&
        this.params.contract_source.contract_type &&
        this.params.contract_source.contract_type.main_type === "stock" &&
        ["采购合同（需入库）", "存货其他类（不入库）", "仓储物流合同"].includes(
          this.params.contract_source.contract_type.sub_type
        )
      );
    },
    spu_price_total() {
      if (!this.needSpu) {
        return 0;
      }
      const total = this.expense.expense_spus
        .reduce((total, item) => {
          return math.eval(`${total}+${item.amount || 0}`);
        }, 0)
        .toFixed(2);
        console.log(total)
      return Number(total);
    },
    fields() {
      const _this = this;
      let finacer_2 = [];
      if (this.is_financer || this.is_financer_assistant) {
        finacer_2 = this.finacer_fields;
        // 迭代删除
        // finacer_1 = [{
        //     label: '费用类型',
        //     key: 'expense_type_id',
        //     cols:6,
        //     type:'autocompletes',
        //     'item-value':'id',
        //     'item-text':'full_name',
        //     items: this.items,
        //     required: true,
        //     rules: [commonValidateRuleGg],
        // }]
      }
      const expense_spus = [];

      if (this.needSpu) {
        expense_spus.push({
          label: "",
          key: "expense_spus",
          cols: 12,
        });
      }
      return [
        {
          label: `项目${this.index + 1}`,
          key: "name",
          required: true,
          rules: [commonValidateRuleGg],
          cols: 6,
        },
        {
          label: "项目金额",
          key: "price",
          type: "number_field",
          required: true,
          scopedSlots: {
            "append-outer": () => {
              return (
                <VBtn
                  fab
                  dark
                  x-small
                  color="primary"
                  on={{
                    click: () => {
                      _this.expense.price = _this.team_price_total;
                      _this.changeInvoice();
                    },
                  }}
                >
                  <VIcon>mdi-calculator</VIcon>
                </VBtn>
              );
            },
          },
          rules: [
            commonValidateRuleGg,
            (val) => {
              if (Number(val) === _this.team_price_total) {
                return true;
              }
              return "各团队金额之和需要等于项目金额";
            },
            (val) => {
              if (_this.needSpu) {
                if (Number(val) === _this.spu_price_total) {
                  return true;
                }
                return "各SPU金额之和需要等于项目金额";
              }
              return true
            },
          ],
          cols: 6,
          change: () => {
            _this.$nextTick(() => {
              _this.changePrice();
              _this.changeInvoice();
            });
          },
        },
        {
          label: "",
          key: "teams",
          cols: 12,
        },
        ...expense_spus,
        {
          label: "发票信息",
          key: "invoice_price",
          price_key: "price",
          // required: true,
          type: "invoice_info_field",
          cols: 6,
          // rules:  [commonValidateRuleGo]
        },
        {
          type: "empty",
          cols: 6,
        },
        ...finacer_2,
        {
          label: "备注",
          key: "desc",
          cols: 12,
        },
      ];
    },
    conctract_invoice_is_not_in() {
      const { invoice_type, tax_rate } = this.expense || {};
      const invoice_rates = (this.params.contract_invoices || [])
        .filter((i) => ["special", "e-special"].includes(i.invoice_type))
        .map((i) => Number(i.tax_rate));

      return (
        Number(invoice_type) === 1 &&
        invoice_rates.length !== 0 &&
        !invoice_rates.includes(Number(tax_rate))
      );
    },
  },
  watch: {
    ["expense.price"](val) {
      if (this.expense && Number(this.expense.invoice_type) === 1) {
        let tax = math.eval(
          `${Number(val) || 0}/(1+${Number(this.expense.tax_rate) ||
            0})*${Number(this.expense.tax_rate) || 0}`
        );
        tax = tax.toFixed(2);
        this.expense.tax = tax;
      }
    },
    value(val) {
      this.expense = val;
    },
    expense(val) {
      this.$emit("input", val);
    },
    needSpu(val) {
      if (!val) {
        // 清空数组
        this.expense.expense_spus = [];
      } else {
        if (!this.expense.expense_spus || !Array.isArray(this.expense.expense_spus) || this.expense.expense_spus.length === 0) {
          this.expense.expense_spus = [createSpu()]
        }
      }
    }
  },
  created() {
    this.getUsedExpenseTypes();
  },
  mounted() {
    // console.log(this.params);
    // console.log(this.value);
  },
  methods: {
    getUsedExpenseTypes() {
      this.items = [];
      ExpenseTypeUtil.getUsedLastGenerationTypes().then((data) => {
        data.expense_types.forEach((type) => {
          this.items.push(type);
        });
      });
    },
    // 修改税额
    changeInvoice() {
      if (!this.$refs.invoice || !this.$refs.invoice.inner) {
        return;
      }
      this.$refs.invoice.inner.taxDataChange();
    },
    changePrice() {
      this.$emit("changePrice", this.team_price_total);
    },
    validate() {
      return this.$refs.base.validate();
    },
    resetValidation() {
      return this.$refs.base.resetValidation();
    },
    del() {
      this.$vModal.confirm({
        title: "提示",
        content: `是否删除第${this.index + 1}条项目分摊`,
        onOk: () => {
          this.$emit("del", this.index);
        },
      });
    },
  },
  render() {
    const _this = this;
    return (
      <VCard style="margin-bottom:10px" flat light outlined>
        <VCardText>
          {_this.total !== 1 && (
            <VBtn
              small
              color="warning"
              dark
              on={{
                click: _this.del,
              }}
            >
              删除
            </VBtn>
          )}
          <VForm
            ref="base"
            fields={_this.fields}
            v-model={_this.expense}
            scopedSlots={{
              invoice_price: ({ field } = {}) => {
                return (
                  <div style="position:relative">
                    <InvoiceInfoField
                      ref="invoice"
                      v-model={_this.expense}
                      field={{
                        ...field,
                        key: "invoice_type",
                      }}
                    />
                    {this.conctract_invoice_is_not_in && (
                      <p class={styles["warning-text"]}>
                        付款中关联的发票与合同申请中的发票税率不一致，请核对修改后重新尝试
                      </p>
                    )}
                  </div>
                );
              },
              // expense_type_id:() => {
              //     return <VExpenseTypeSelector
              //         value={_this.expense.expense_type_id}
              //         clearable
              //         // required
              //         // rules={[commonValidateRuleGo]}
              //         label="费用类型"
              //         placeholder="请选择"
              //         on={{
              //             change:(data) => {
              //                 _this.expense.expense_type_id = data
              //             }
              //         }}
              //     />
              // },
              teams: () => {
                return (
                  <div>
                    {_this.expense.expense_teams.map((item, index) => {
                      return (
                        <VRow>
                          <VCol cols="3">
                            <SpecialTeamSelector
                              v-model={item}
                              field={{
                                key: "team_id",
                                label: `团队${index + 1}`,
                                required: true,
                                rules: [commonValidateRuleGo],
                              }}
                            />
                          </VCol>
                          <VCol cols="3">
                            <NumberField
                              v-model={item}
                              field={{
                                required: true,
                                key: "price",
                                label: "团队金额",
                                scopedSlots: {
                                  label: () => (
                                    <span>
                                      <span style="color:red">*</span>团队金额
                                    </span>
                                  ),
                                },
                                change: () => {
                                  _this.$nextTick(() => _this.changePrice());
                                },
                                rules: [commonValidateRuleGo],
                              }}
                            />
                          </VCol>
                          <VCol cols="4">
                            <TextField
                              v-model={item}
                              field={{
                                key: "desc",
                                label: "备注",
                              }}
                            />
                          </VCol>
                          {!this.params.is_period_closed && (
                            <VCol cols="2">
                              {_this.expense.expense_teams.length ===
                                index + 1 && (
                                <VBtn
                                  fab
                                  dark
                                  x-small
                                  color="primary"
                                  style="margin-right:10px"
                                  on={{
                                    click: () => {
                                      _this.expense.expense_teams.push(
                                        createTeam()
                                      );
                                    },
                                  }}
                                >
                                  <VIcon dark dense>
                                    mdi-plus
                                  </VIcon>
                                </VBtn>
                              )}
                              {_this.expense.expense_teams.length > 1 && (
                                <VPopDel
                                  title="确定删除该条团队？"
                                  icon="mdi-minus"
                                  on={{
                                    submit: () => {
                                      _this.expense.expense_teams.splice(
                                        index,
                                        1
                                      );
                                    },
                                  }}
                                >
                                  <VBtn fab dark x-small color="warning">
                                    <VIcon dark dense>
                                      mdi-minus
                                    </VIcon>
                                  </VBtn>
                                </VPopDel>
                              )}
                            </VCol>
                          )}
                        </VRow>
                      );
                    })}
                  </div>
                );
              },
              expense_spus: () => {
                return (
                  <div>
                    {_this.expense.expense_spus.map((item, index) => {
                      return (
                        <VRow>
                          <VCol cols="3">
                            <AutoCompleteSelector
                              v-model={item}
                              field={{
                                label: `SPU${index + 1}`,
                                "item-value": "id",
                                "item-text": "spu_name",
                                key: "cya_spu_id",
                                api: _this.$util.api.cya_spu_select_search,
                                rules: [commonValidateRuleGo],
                                required: true,
                                handle_data: (data = []) => {
                                  if (Array.isArray(data)) {
                                    const list = data.map((item) => ({
                                      ...item,
                                    //   spu_name_full: `${item.spu_name}${item.tail_num}`,
                                    }));
                                    return list;
                                  }
                                },
                                item_slot: (h, i) => {
                                    return <div>
                                        {i.spu_name}{i.tail_num}
                                    </div>
                                }
                              }}
                            />
                          </VCol>
                          <VCol cols="3">
                            <NumberField
                              v-model={item}
                              field={{
                                required: true,
                                key: "amount",
                                label: "SPU金额",
                                scopedSlots: {
                                  label: () => (
                                    <span>
                                      <span style="color:red">*</span>SPU金额
                                    </span>
                                  ),
                                },
                                change: () => {
                                  _this.$nextTick(() => _this.$forceUpdate());
                                },
                                rules: [commonValidateRuleGo],
                              }}
                            />
                          </VCol>
                          <VCol cols="4">
                            <TextField
                              v-model={item}
                              field={{
                                key: "desc",
                                label: "备注",
                              }}
                            />
                          </VCol>
                          {!this.params.is_period_closed && (
                            <VCol cols="2">
                              {_this.expense.expense_spus.length ===
                                index + 1 && (
                                <VBtn
                                  fab
                                  dark
                                  x-small
                                  color="primary"
                                  style="margin-right:10px"
                                  on={{
                                    click: () => {
                                      _this.expense.expense_spus.push(
                                        createSpu()
                                      );
                                    },
                                  }}
                                >
                                  <VIcon dark dense>
                                    mdi-plus
                                  </VIcon>
                                </VBtn>
                              )}
                              {_this.expense.expense_spus.length > 1 && (
                                <VPopDel
                                  title="确定删除该条SPU？"
                                  icon="mdi-minus"
                                  on={{
                                    submit: () => {
                                      _this.expense.expense_spus.splice(
                                        index,
                                        1
                                      );
                                    },
                                  }}
                                >
                                  <VBtn fab dark x-small color="warning">
                                    <VIcon dark dense>
                                      mdi-minus
                                    </VIcon>
                                  </VBtn>
                                </VPopDel>
                              )}
                            </VCol>
                          )}
                        </VRow>
                      );
                    })}
                  </div>
                );
              },
            }}
          />
        </VCardText>
      </VCard>
    );
  },
};
